/**
 * @flow
 * @relayHash 1b804d74e288330da5a978bfbe5165ec
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PendingOrdersQueryVariables = {||};
export type PendingOrdersQueryResponse = {|
  +ordersPendingJobGeneration: $ReadOnlyArray<{|
    +order: {|
      +id: string,
      +orderNumber: string,
      +customer: {|
        +id: string,
        +name: string,
      |},
    |},
    +pendingCount: number,
  |}>
|};
export type PendingOrdersQuery = {|
  variables: PendingOrdersQueryVariables,
  response: PendingOrdersQueryResponse,
|};
*/


/*
query PendingOrdersQuery {
  ordersPendingJobGeneration {
    order {
      id
      orderNumber
      customer {
        id
        name
      }
    }
    pendingCount
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "ordersPendingJobGeneration",
    "storageKey": null,
    "args": null,
    "concreteType": "OrderPendingJobGeneration",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "order",
        "storageKey": null,
        "args": null,
        "concreteType": "Order",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "orderNumber",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "customer",
            "storageKey": null,
            "args": null,
            "concreteType": "Customer",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "pendingCount",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PendingOrdersQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "PendingOrdersQuery",
    "argumentDefinitions": [],
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "PendingOrdersQuery",
    "id": null,
    "text": "query PendingOrdersQuery {\n  ordersPendingJobGeneration {\n    order {\n      id\n      orderNumber\n      customer {\n        id\n        name\n      }\n    }\n    pendingCount\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7688dfe8cb871326d9c1e8de61972703';
module.exports = node;
